import { render, staticRenderFns } from "./ParcelContainersSection.vue?vue&type=template&id=54cbb590&scoped=true&"
import script from "./ParcelContainersSection.vue?vue&type=script&lang=js&"
export * from "./ParcelContainersSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelContainersSection.vue?vue&type=style&index=0&id=54cbb590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cbb590",
  null
  
)

export default component.exports